import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable } from "rxjs";
const partenariat_API = "https://notregrandbleu.herokuapp.com/partenariat/";

const httpOptions = {
  headers: new HttpHeaders({ "Content-Type": "application/json" })
};
@Injectable({
  providedIn: 'root'
})
export class PartenariatService {

  public Afficherpartenariat(): Observable<any> {
    return this.http.get(partenariat_API , httpOptions);
  }

  addPartenariat(partenariat): Observable<any> {
    return this.http.post(partenariat_API + "addPartenariat", partenariat ,httpOptions );
  }
  deletePartenariat(id): Observable<any> {
    return this.http.get(partenariat_API + "supprimer/"+ id ,httpOptions );
  }
  modify(partenariat):Observable<any>
  {
    return this.http.put(partenariat_API+ "modifier" ,  partenariat , httpOptions );
  }

  constructor(private http: HttpClient) { }
}
